/**
 * Shared Tailwind class strings for recap table cells.
 * Single source of truth — update here, every cell follows.
 */

/**
 * Numeric input cells (quantity, weight, price). Sized to match the
 * read-only display — same `text-xs` text + a row height (`h-7`) close
 * to natural inline height — so switching between modify mode and the
 * read-only/locked view doesn't shift row heights or font size. Without
 * this, save → lock pulse visibly reflows the table (rows briefly
 * shrink/grow + font hops sm → xs).
 */
export const CELL_INPUT =
  "w-full px-2 py-0.5 text-xs h-7 border border-gray-200 bg-gray-50/80 text-gray-700 rounded transition-colors placeholder:text-gray-400 focus:outline-none focus:bg-white focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:text-gray-900 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-900";

/** Unit selector input (same base, cursor-pointer, conditional text color) */
export const CELL_INPUT_SELECT =
  "w-full h-7 px-2 py-0.5 text-xs border rounded transition-colors border-gray-200 bg-gray-50/80";

export const CELL_INPUT_SELECT_FOCUS =
  "focus:outline-none focus:bg-white focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:text-gray-900";

/**
 * Applied to UnitCell's read-only display when the row is locked. Pairs with
 * the cell's own `text-gray-900` so values stay clearly legible — "disabled"
 * is conveyed by the muted background + cursor, NOT by dimming the text
 * (which previously sat at opacity 0.5 and rendered near-invisibly).
 */
export const CELL_INPUT_DISABLED = "cursor-not-allowed bg-gray-100";

/** Modify-mode (recap_modify_mode) — soft amber accent for pending edits. */
export const PENDING_EDIT_ROW_CLASS = "border-l-[3px] border-l-amber-300";

export const PENDING_ADD_ROW_CLASS =
  "border-l-[3px] border-l-amber-400 bg-amber-50/40";

export const PENDING_DELETE_ROW_CLASS = "opacity-50 line-through";

export const PENDING_EDIT_CELL_CLASS =
  "ring-1 ring-amber-300 ring-offset-0 rounded";
